import request from '@/utils/request'

// 获取合同付款任务主表信息
export function coopPayCreateHead(businessId) {
  return request({
    url: `/api/coop/cmPayApply/selectInfo/${businessId}`,
    method: 'get'
  })
}
